module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section section-white"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-position": "left",
      "label-width": "180px"
    }
  }, [_c('div', {
    staticClass: "section-body"
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否开启：",
      "prop": "ad_title"
    }
  }, [_c('el-switch', {
    attrs: {
      "width": 60,
      "active-value": "true",
      "inactive-value": "false",
      "inactive-color": "#ccc",
      "active-text": "开启",
      "inactive-text": "关闭",
      "active-color": "#13ce66"
    },
    model: {
      value: (_vm.form.is_open),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_open", $$v)
      },
      expression: "form.is_open"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "注册引导广告标题：",
      "prop": "ad_title"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "340px"
    },
    attrs: {
      "placeholder": "用于门店小程序注册引导入口标题"
    },
    model: {
      value: (_vm.form.ad_title),
      callback: function($$v) {
        _vm.$set(_vm.form, "ad_title", $$v)
      },
      expression: "form.ad_title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "注册引导图片："
    }
  }, [_c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("只能上传jpg/png文件，且不超过2M （建议尺寸：400px * 450px）")]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("引导用户授权手机号注册，类似新用户专享广告图片")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": _vm.handleImgChange
    }
  }, [(_vm.form.ad_pic) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.wximageurl + _vm.form.ad_pic
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])]), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "请选择赠送会员卡类型："
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.vipGradeChange
    },
    model: {
      value: (_vm.membercards.index_value),
      callback: function($$v) {
        _vm.$set(_vm.membercards, "index_value", $$v)
      },
      expression: "membercards.index_value"
    }
  }, _vm._l((_vm.vipGrade), function(item, index) {
    return _c('el-radio', {
      key: index,
      attrs: {
        "label": index
      },
      on: {
        "click": function($event) {
          return _vm.vipGradeClick(index, item)
        }
      }
    }, [_vm._v(_vm._s(item.grade_name))])
  }), 1)], 1), _vm._v(" "), (_vm.priceList.length > 0) ? _c('el-form-item', {
    attrs: {
      "label": "请选择赠送会员卡："
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.membercards.card_type),
      callback: function($$v) {
        _vm.$set(_vm.membercards, "card_type", $$v)
      },
      expression: "membercards.card_type"
    }
  }, _vm._l((_vm.priceList), function(item, index) {
    return _c('el-radio', {
      key: index,
      attrs: {
        "label": item.name
      }
    }, [_vm._v(_vm._s(item.desc) + "(" + _vm._s(item.price) + "元)")])
  }), 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "section-footer with-border content-center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保 存")])], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-53427c2e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53427c2e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/promotions/saleMemberCard.vue
// module id = 2715
// module chunks = 0